import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path:"/",
    redirect:"/login"
  },
  {
    path: '/login',
    name: 'login',
    component: ()=>import("views/login/index.vue")
  },
  {
    path:"/ship",
    name:"ship",
    component:()=>import("views/home/home.vue"),
    children:[
      {
        path:"/",
        redirect:"/ship/home"
      },
      {//首页
        path:"/ship/home",
        name:"ship.home",
        component:()=>import("views/wmsPages/ship/home.vue")
      },
      {//待发货订单列表
        path:"/ship/pendingOrders",
        name:"ship.pendingOrders",
        component:()=>import("views/wmsPages/ship/pendingOrders.vue"),
      },
      {//已完成订单
        path:"/ship/finishedOrder",
        name:"ship.finishedOrder",
        component:()=>import("views/wmsPages/ship/finishedOrder.vue"),
      },
      {//单品发货
        path:"/ship/singleShipment",
        name:"ship.singleShipment",
        component:()=>import("views/wmsPages/ship/singleShipment.vue"),
      },
      {//单品配货
        path:"/ship/singleMatchGoo",
        name:"ship.singleMatchGoo",
        component:()=>import("views/wmsPages/ship/singleMatchGoods.vue"),
      },
      {//多品配货
        path:"/ship/multiDispensin",
        name:"ship.multiDispensing",
        component:()=>import("views/wmsPages/ship/multiDispensing.vue"),
      },
      {//多品发货
        path:"/ship/mutiShipment",
        name:"ship.mutiShipment",
        component:()=>import("views/wmsPages/ship/mutiShipment.vue"),
      },
      {//多品分拣
        path:"/ship/multiSorting",
        name:"ship.multiSorting",
        component:()=>import("views/wmsPages/ship/multiSorting.vue"),
      },
      {//称重出库
        path:"/ship/weighingOut",
        name:"ship.weighingOut",
        component:()=>import("views/wmsPages/ship/weighingOut.vue"),
      },
      {//篮子列表
        path:"/ship/basket",
        name:"ship.basket",
        component:()=>import("views/wmsPages/ship/basket.vue"),
      },
      {//发货控制
        path:"/ship/shippingContro",
        name:"ship.shippingControl",
        component:()=>import("views/wmsPages/ship/shippingControl.vue"),
      },
      {//任务单信息
        path:"/ship/missionListInf",
        name:"ship.missionListInfo",
        component:()=>import("views/wmsPages/ship/missionListInfo.vue"),
      },
      {//占用篮子
        path:"/ship/basketOccupied",
        name:"ship.basketOccupied",
        component:()=>import("views/wmsPages/ship/basketOccupied.vue"),
      },
      {//蓝子类型
        path:"/ship/basketType",
        name:"ship.basketType",
        component:()=>import("views/wmsPages/ship/basketType.vue"),
      },
      {//SKU固定收费
        path: "/ship/currencyInfo",
        name: "ship.currencyInfo",
        component: () => import("views/wmsPages/ship/currencyInfo.vue"),
      },
      {//菜单列表
        path:"/ship/sysMenu",
        name:"ship.sysMenu",
        component:()=>import("views/wmsPages/ship/sysMenu.vue"),
      },
      {//角色列表
        path:"/ship/sysRole",
        name:"ship.sysRole",
        component:()=>import("views/wmsPages/ship/sysRole.vue"),
      },
      {//用户列表
        path:"/ship/sysUser",
        name:"ship.sysUser",
        component:()=>import("views/wmsPages/ship/sysUser.vue"),
      },
      {//耗材管理
        path:"/ship/packagSetting",
        name:"ship.packagSetting",
        component:()=>import("views/wmsPages/ship/packagSetting.vue"),
      },
      {//耗材类型
        path:"/ship/consumables",
        name:"ship.consumables",
        component:()=>import("views/wmsPages/ship/consumables.vue"),
      },
      {//操作日志
        path:"/ship/oprateLog",
        name:"ship.oprateLog",
        component:()=>import("views/wmsPages/ship/oprateLog.vue"),
      },
      {//一件待发费设置
        path:"/ship/Momentumfee", 
        name:"ship.Momentumfee",
        component:()=>import("views/wmsPages/ship/Momentumfee.vue"),
      },
      {//扫描拍照
        path:"/ship/scanpictures", 
        name:"ship.scanpictures",
        component:()=>import("views/wmsPages/ship/scanpictures.vue"),
      },
      {//拍照列表
        path:"/ship/photolist", 
        name:"ship.photolist",
        component:()=>import("views/wmsPages/ship/photolist.vue"),
      },
      {//取消订单
        path:"/ship/cancellationOrder", 
        name:"ship.cancellationOrder",
        component:()=>import("views/wmsPages/ship/cancellationOrder.vue"),
      },
      {//三方仓配货
        path:"/ship/twDistribution", 
        name:"ship.TWDistribution",
        component:()=>import("views/wmsPages/ship/twdistribution.vue"),
      },
      {//三方仓分拣
        path:"/ship/twSorting", 
        name:"ship.TWSorting",
        component:()=>import("views/wmsPages/ship/twsorting.vue"),
      },
      {//三方仓发货
        path:"/ship/twShipments", 
        name:"ship.twShipments",
        component:()=>import("views/wmsPages/ship/twshipments.vue"),
      },
      {//测试扣费
        path:"/ship/csFeededuction", 
        name:"ship.csFeededuction",
        component:()=>import("views/wmsPages/ship/csFeededuction.vue"),
      },
      {//篮子使用日志
        path:"/ship/BasketListLog", 
        name:"ship.BasketListLog",
        component:()=>import("views/wmsPages/ship/BasketListLog.vue"),
      },
      { //处理三方仓回传异常
        path:'/ship/disposeTWAbnormal',
        name:'ship.disposeTWAbnormal',
        component:()=>import("views/wmsPages/ship/disposeTWAbnormal.vue")
      },
      // {//测试pdfjs
      //   path:"/ship/testpdfjs", 
      //   name:"ship.testpdfjs",
      //   component:()=>import("views/wmsPages/ship/testpdfjs.vue"),
      // },
    ]
  },
  {
    path:"/basis",
    name:"basis",
    component:()=>import("views/wmsPages/ship/shippingControl.vue"),
  },
  {
    path:'*',
    name:'404',
    component:()=>import("views/wmsPages/ship/errorpage.vue"),
  }
]

//避免冗余导航到当前位置
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router
